// {
//   "name": "iconic-timeline-first.js",
//   "author": "Arham Web Works",
//   "description": "Copying in any form is strictly prohibited. Any instance of copying will be subject to legal action and accountability under the law."
// }

(() => {
    if (customElements.get('iconic-timeline-first')) {
      return;
    }
    class IconicTimelineButtons extends HTMLElement {
      constructor() {
        super();
        this.initializeTimelineButtons = this.initializeTimelineButtons.bind(this);
      }
      connectedCallback() {
        this.initializeTimelineButtons();
  
        if (Shopify.designMode) {
          document.addEventListener('shopify:section:load', this.initializeTimelineButtons);
          document.addEventListener('shopify:section:unload', this.initializeTimelineButtons);
          document.addEventListener('shopify:section:select', this.initializeTimelineButtons);
          document.addEventListener('shopify:section:deselect', this.initializeTimelineButtons);
          document.addEventListener('shopify:section:reorder', this.initializeTimelineButtons);
          document.addEventListener('shopify:block:select', this.initializeTimelineButtons);
          document.addEventListener('shopify:block:deselect', this.initializeTimelineButtons);
        }
      }
      disconnectedCallback() {
        if (Shopify.designMode) {
          document.removeEventListener('shopify:section:load', this.initializeTimelineButtons);
          document.removeEventListener('shopify:section:unload', this.initializeTimelineButtons);
          document.removeEventListener('shopify:section:select', this.initializeTimelineButtons);
          document.removeEventListener('shopify:section:deselect', this.initializeTimelineButtons);
          document.removeEventListener('shopify:section:reorder', this.initializeTimelineButtons);
          document.removeEventListener('shopify:block:select', this.initializeTimelineButtons);
          document.removeEventListener('shopify:block:deselect', this.initializeTimelineButtons);
        }
      }
    initializeTimelineButtons() {
    const buttons = this.querySelectorAll('.iconic-timeline-years button');
    const items = this.querySelectorAll('.iconic-timeline-item');

    if (!buttons.length || !items.length) return;

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        buttons.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        const selectedYear = btn.dataset.year.toLowerCase().replace(/\s+/g, '-');
        const selectedBlockId = btn.dataset.blockId;
        
        items.forEach(item => {
          const itemYear = item.dataset.year?.toLowerCase();
          const itemBlockId = item.dataset.blockId;
  
          if (itemYear === selectedYear && itemBlockId === selectedBlockId) {
            item.style.setProperty('display', 'flex');
          } else {
            item.style.setProperty('display', 'none', 'important');
          }
        });
      });
    });
    buttons[0].click(); // Auto-click the first button
  }
    }
    customElements.define('iconic-timeline-first', IconicTimelineButtons);
  })();
  